import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/es/servicios/clinical-solutions/servicios-de-clínicos-expertos")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/servicios-de-clínicos-expertos"),
  component: ClinicalOffering,
});

